import { api } from "./client.js";
import type { ShadowDiff } from "@cas/shared";

export type { ShadowDiff };

export const shadowDiffsApi = {
  query: (hours = 24, limit = 200) =>
    api.get<{ diffs: ShadowDiff[] }>(`manage/shadow/diffs?hours=${hours}&limit=${limit}`).then(r => r.diffs),
};
